import { render, staticRenderFns } from "./promo_menu.vue?vue&type=template&id=6fcc6f4a"
import script from "./promo_menu.vue?vue&type=script&lang=js"
export * from "./promo_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports